<template>
    <Head title="Mapping Shift"></Head>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <Toast />
                <Toolbar class="mb-4">
                    <template v-slot:start>
                        <div class="my-2">
                            <Button
                                label="New"
                                icon="pi pi-plus"
                                class="p-button-success mr-2"
                                @click="openNew"
                            />
                            <Button
                                label="Delete"
                                icon="pi pi-trash"
                                class="p-button-danger"
                                @click="confirmDeleteSelected"
                                :disabled="
                                    !selectedModels || !selectedModels.length
                                "
                            />
                        </div>
                    </template>
                    <template v-slot:end>
                        <div class="p-fluid formgrid grid">
                            <div class="field col-12 md:col-4">
                                <Calendar v-model="start_date" :showIcon="true" dateFormat="dd-mm-yy" placeholder="Dari Tanggal">
                                </Calendar>
                            </div>
                            <div class="field col-12 md:col-4">
                                <Calendar v-model="end_date" :showIcon="true" dateFormat="dd-mm-yy" :showButtonBar="true" placeholder="Sampai Tanggal">
                                </Calendar>
                            </div>
                            <div class="field col-12 md:col-4">
                                <Button
                                        label="Cari"
                                        icon="pi pi-zoom"
                                        class="p-button-primary ml-2"
                                        @click="changeFilters"
                                    />
                            </div>
                        </div>
                    </template>
                </Toolbar>

                <DataTable
                    ref="dt"
                    :value="models"
                    :lazy="true"
                    dataKey="id"
                    v-model:selection="selectedModels"
                    :paginator="true"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    v-model:filters="filters"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    :selectAll="selectAll"
                    @select-all-change="onSelectAllChange"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Manage Pemetaan Shift</h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText
                                    @change="onFilter($event)"
                                    v-model="filters['global'].value"
                                    placeholder="Search..."
                                />
                            </span>
                        </div>
                    </template>

                    <Column
                        selectionMode="multiple"
                        headerStyle="width: 3rem"
                    ></Column>
                    <Column
                        field="tanggal"
                        header="Tanggal"
                        :sortable="true"
                        headerStyle="width:40%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Tanggal</span>
                            {{ slotProps.data.tanggal }}
                        </template>
                    </Column>
                    <Column
                        field="shift_karyawan"
                        header="Shift"
                        headerStyle="width:40%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Shift Karyawan</span>
                            {{ slotProps.data.shift_karyawan }}
                        </template>
                    </Column>
                    <Column
                        field="jam_masuk"
                        header="Jam Masuk"
                        headerStyle="width:40%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Jam Masuk</span>
                            {{ slotProps.data.jam_masuk }}
                        </template>
                    </Column>
                    <Column
                        field="jam_keluar"
                        header="Jam Keluar"
                        headerStyle="width:40%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Jam Keluar</span>
                            {{ slotProps.data.jam_keluar }}
                        </template>
                    </Column>
                    <Column headerStyle="width:15%;min-width:10rem;">
                        <template  #body="slotProps">
                            <Button
                                v-if="!slotProps.data.jam_absen"
                                icon="pi pi-pencil"
                                class="p-button p-button-primary mr-2"
                                @click="editModel(slotProps.data)"
                            />
                            <Button
                                v-if="!slotProps.data.jam_absen"
                                icon="pi pi-trash"
                                class="p-button p-button-warning mt-2"
                                @click="confirmDeleteModel(slotProps.data)"
                            />
                            <p v-if="slotProps.data.jam_absen">Sudah Absen</p>
                        </template>
                    </Column>
                </DataTable>


            </div>
        </div>
    </div>
<Dialog
    v-model:visible="modelDialog"
    :style="{ width: '450px' }"
    header="User Detail"
    :modal="true"
    class="p-fluid"
>
    <div class="field">
        <label for="name">Shift</label>
        <Dropdown v-model="model.shift" :options="shifts" optionLabel="name" placeholder="Pilih Shift" />
        <small class="p-invalid" v-if="submitted && !model.shift"
            >Shift is required.</small
        >
    </div>
    <div class="field">
        <label for="tanggal_mulai">Tanggal Mulai</label>
        <Calendar id="tanggal_mulai" v-model="model.tanggal_mulai" :show-icon="true"/>
        <small
            class="p-invalid"
            v-if="submitted && !model.tanggal_mulai"
            >Tanggal Mulai is required.</small
        >
    </div>
    <div class="field">
        <label for="tanggal_akhir">Tanggal Akhir</label>
        <Calendar id="tanggal_akhir" v-model="model.tanggal_akhir" :show-icon="true" />
        <small
            class="p-invalid"
            v-if="submitted && !model.tanggal_mulai"
            >Tanggal Mulai is required.</small
        >
    </div>
    <template #footer>
        <Button
            label="Cancel"
            icon="pi pi-times"
            class="p-button-text"
            @click="hideDialog"
        />
        <Button
            label="Save"
            icon="pi pi-check"
            class="p-button-text"
            @click="saveModel"
        />
    </template>
</Dialog>

<Dialog
    v-model:visible="editModelDialog"
    :style="{ width: '450px' }"
    header="Edit Shift"
    :modal="true"
    class="p-fluid"
>
    <div class="field">
        <label for="name">Shift</label>
        <Dropdown v-model="model.shift_id" :options="shifts" optionValue="id" optionLabel="name" placeholder="Pilih Shift" />
        <small class="p-invalid" v-if="submitted && !model.shift"
            >Shift is required.</small
        >
    </div>
    <template #footer>
        <Button
            label="Cancel"
            icon="pi pi-times"
            class="p-button-text"
            @click="hideEditDialog"
        />
        <Button
            label="Save"
            icon="pi pi-check"
            class="p-button-text"
            @click="updateModel"
        />
    </template>
</Dialog>

<Dialog
    v-model:visible="deleteModelDialog"
    :style="{ width: '450px' }"
    header="Confirm"
    :modal="true"
>
    <div class="flex align-items-center justify-content-center">
        <i
            class="pi pi-exclamation-triangle mr-3"
            style="font-size: 2rem"
        />
        <span v-if="model"
            >Are you sure you want to delete
            <b>{{ model.name }}</b
            >?</span
        >
    </div>
    <template #footer>
        <Button
            label="No"
            icon="pi pi-times"
            class="p-button-text"
            @click="deleteModelDialog = false"
        />
        <Button
            label="Yes"
            icon="pi pi-check"
            class="p-button-text"
            @click="deleteModel"
        />
    </template>
</Dialog>

<Dialog
    v-model:visible="deleteModelsDialog"
    :style="{ width: '450px' }"
    header="Confirm"
    :modal="true"
>
    <div class="flex align-items-center justify-content-center">
        <i
            class="pi pi-exclamation-triangle mr-3"
            style="font-size: 2rem"
        />
        <span v-if="model"
            >Are you sure you want to delete the selected
            models?</span
        >
    </div>
    <template #footer>
        <Button
            label="No"
            icon="pi pi-times"
            class="p-button-text"
            @click="deleteModelsDialog = false"
        />
        <Button
            label="Yes"
            icon="pi pi-check"
            class="p-button-text"
            @click="deleteSelectedModels"
        />
    </template>
</Dialog>
</template>

<script>
    import AppLayout from "../../../Layouts/AppLayout";
    import { FilterMatchMode } from "primevue/api";
    import { Head } from "@inertiajs/inertia-vue3";
    import Checkbox from "primevue/checkbox";
    import Button from "primevue/button";
    import InputText from "primevue/inputtext";
    import Password from "primevue/password";
    import Message from "primevue/message";
    import Toolbar from "primevue/toolbar";
    import Toast from "primevue/toast";
    import FileUpload from "primevue/fileupload";
    import DataTable from "primevue/datatable";
    import Column from "primevue/column";
    import InputNumber from "primevue/inputnumber";
    import Dropdown from "primevue/dropdown";
    import RadioButton from "primevue/radiobutton";
    import Dialog from "primevue/dialog";
    import Calendar from "primevue/calendar";
    import DatatableService from "../../../Services/DatatableService";
    import { Inertia } from "@inertiajs/inertia";
    import axios from "axios";

    export default {
        name: "Index",
        layout: AppLayout,
        components: {
            Head,
            Checkbox,
            Button,
            InputText,
            Password,
            Message,
            Toolbar,
            Toast,
            FileUpload,
            DataTable,
            Column,
            InputNumber,
            Dropdown,
            RadioButton,
            Dialog,
            Dropdown,
            Calendar
        },
        data() {
            return {
                searchFilter: "",
                filters: {
                    global: {
                        value: null,
                        matchMode: FilterMatchMode.CONTAINS,
                    },
                    status: { value: null, matchMode: FilterMatchMode.EQUALS },
                },
                lazyParams: {
                    global: {
                        value: null,
                        matchMode: FilterMatchMode.CONTAINS,
                    },
                    status: { value: null, matchMode: FilterMatchMode.EQUALS },
                },
                loading: true,
                totalRecords: 0,
                selectedModel: null,
                model: {
                    id: null,
                    name: null,
                    tanggal: null,
                    shift_karyawan: null,
                    jam_keluar: null,
                    jam_masul: null,
                },
                modelDialog: false,
                models: null,
                deleteModelDialog: false,
                deleteModelsDialog: false,
                selectedModels: null,
                submitted: false,
                selectAll: false,
                shifts: [],
                start_date: null,
                end_date: null,
                editModelDialog: false,

            };
        },
        datatableService: null,
        created() {
            this.datatableService = new DatatableService();
            this.initFilters();
        },
        mounted() {
            this.loading = true;
            this.lazyParams = {
                first: 0,
                rows: this.$refs.dt.rows,
                sortField: "id",
                sortOrder: -1,
                filters: this.filters,
            };
            this.loadLazyData();
            this.loadShift();
        },
        methods: {
            loadLazyData() {
                const user_id = window.location.pathname.split('/')[2];
                this.loading = true;
                this.datatableService
                    .getData(this.route("mapping.shift.datatable", user_id), this.lazyParams)
                    .then((data) => {
                        this.models = data.data;
                        this.totalRecords = data.total;
                        this.loading = false;
                    });
            },
            loadShift() {
                axios.get(this.route('api.shift.index'))
                .then((data) => {
                    this.shifts = data.data.data.data
                })
                .catch((err) => {
                    console.log(err)
                })
            },
            onSelectAllChange(event) {
                const selectAll = event.checked;
                if (selectAll) {
                    this.datatableService.getData(this.route("user.index"),this.lazyParams).then((data) => {
                        this.selectAll = true;
                        this.selectedModels = data.data;
                    });
                } else {
                    this.selectAll = false;
                    this.selectedModels = [];
                }
            },
            onRowSelect() {
                this.selectAll = this.selectedModels.length === this.totalRecord;
            },
            onRowUnselect() {
                this.selectAll = false;
            },
            onPage(event) {
                this.lazyParams = event;
                this.loadLazyData();
            },
            onSort(event) {
                this.lazyParams = event;
                this.loadLazyData();
            },
            onFilter(event) {
                this.loadLazyData();
            },
            openNew() {
                this.model = {};
                this.submitted = false;
                this.modelDialog = true;
            },
            hideDialog() {
                this.modelDialog = false;
                this.submitted = false;
            },
            hideEditDialog(){
                this.editModelDialog = false;
                this.submitted = false;
            },
            saveModel(){
                this.submitted = true;
                const user_id = window.location.pathname.split('/')[2];
                if (this.model) {
                    const { shift, tanggal_mulai, tanggal_akhir  } = this.model
                    const data = {
                        shift_id: shift.id,
                        tanggal_mulai,
                        tanggal_akhir
                    }

                    axios
                        .post(this.route(`mapping.shift.store`, user_id), data)
                        .then((response) => {
                            this.$toast.add({
                                severity: "success",
                                summary: "Successful",
                                detail: response.data.message,
                                life: 3000,
                            });
                        })
                        .catch((error) => {
                            this.$toast.add({
                                severity: "error",
                                summary: "Error",
                                detail: "Mapping not created",
                                life: 3000,
                            });
                        });

                    this.modelDialog = false;
                    this.model = {};

                    this.loadLazyData();
                }
            },
            updateModel(){
                this.submitted = true;
                axios
                    .patch(`${this.$page.props.appUrl}api/karyawan/shift/${this.model.id}`, this.model)
                    .then((response) => {
                        this.$toast.add({
                            severity: "success",
                            summary: "Successful",
                            detail: "Mapping Updated",
                            life: 3000,
                        });
                        this.loadLazyData();
                    })
                    .catch((error) => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Mapping not updated",
                            life: 3000,
                        });
                    });

                this.editModelDialog = false;
                this.model = {};
                this.submitted = false;

                this.loadLazyData();
            },
            editModel(model) {
                this.model = { ...model };
                this.editModelDialog = true;
            },
            confirmDeleteModel(model) {
                this.model = model;
                this.deleteModelDialog = true;
            },
            deleteModel() {
                axios
                    .delete(this.route(`mapping.shift.delete`, this.model.id))
                    .then((response) => {
                        this.$toast.add({
                            severity: "success",
                            summary: "Successful",
                            detail: "Shift Deleted",
                            life: 3000,
                        });
                        this.deleteModelDialog = false;
                        this.model = {};
                        this.loadLazyData();
                    })
                    .catch((error) => {
                        console.log(error);
                        this.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Shift not deleted",
                            life: 3000,
                        });
                    });
            },
            confirmDeleteSelected() {
                this.deleteModelsDialog = true;
            },
            deleteSelectedModels() {
                this.models = this.models.filter(
                    (val) => !this.selectedModels.includes(val)
                );
                this.deleteModelsDialog = false;
                this.selectedModels = null;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Models Deleted",
                    life: 3000,
                });
            },
            initFilters() {
                this.filters = {
                    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                };
            },
            changeFilters(){
                this.lazyParams.filters = {
                    global: {value: null, matchMode: FilterMatchMode.CONTAINS},
                    date: {fromDate: this.start_date, toDate: this.end_date},
                };
                this.loadLazyData();
            }
        }
    }
</script>

<style scoped lang="scss">
@import "../../../../assets/demo/badges.scss";
</style>
